import { Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { EditorModalType } from "./ComponentEditorContext";
import { useModalEditorDisplayContext } from "./ModalEditorContext";
import { usePathContext } from "./PathInfo";

interface OpenClickPathEditorButtonProps {
  propName: string;
  value: object;
}

export function OpenClipPathEditorButton(props: OpenClickPathEditorButtonProps) {
  const { showModal, setModalContext } = useModalEditorDisplayContext();
  const { path } = usePathContext();

  const handleOpenClickableAreasEditor = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setModalContext(path, props.value, EditorModalType.clipPathEditor);
      showModal();
    },
    [setModalContext, path, props.value, showModal],
  );

  return (
    <>
      <Typography component={"span"}>{props.propName}: </Typography>
      <Button variant="outlined" onClick={(event) => handleOpenClickableAreasEditor(event)}>
        Edit clip path
      </Button>
    </>
  );
}
